module.exports = __webpack_public_path__ + "img/order.50c8ad55.png";